module.exports = __webpack_public_path__ + "static/img/43022.8a0aca7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/43022.jpg
// module id = DnaR
// module chunks = 1